import "./SystemWork.css";
import "./ResponsiveSystemWork.css";
import Bronze from "../../MedalsSVG/BronzeNoShadow.svg";
import Diamond from "../../MedalsSVG/DiamondNoShadow.svg";
import Gold from "../../MedalsSVG/GoldNoShadow.svg";
import Silver from "../../MedalsSVG/SilverNoShadow.svg";
import { getTranslatedText as translate } from "../../Localization/Translation";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";

const SystemWork = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedState));

  return (
    <div
      className="System-Work-component animate__animated animate__fadeInLeft"
      dir="auto"
    >
      {/* DIAMOND */}
      <div className="medals-container row animate__animated animate__fadeInLeft">
        <div className="col-5 selected-col">
          <span>1</span>
          <img src={Diamond} className="Diamond" alt="Diamond"></img>
          <span>{translate("Diamond", locale)}</span>
        </div>
        <div className="col text-medal-Diamond">
          <span>
            هيّا قم بطلب أكثر من 40 طلبية أو اطلب طلبات بقيمة تتجاوز ال 10000
            ريال سعودي حتى تصبح زبون ألماسي لدينا و تتمتع بالعروض الكثيرة.
          </span>
        </div>
      </div>
      {/* GOLD */}
      <div className="medals-container row animate__animated animate__fadeInLeft animate__delay-1s">
        <div className="col text-medal-Gold">
          <span>
            هيّا قم بطلب أكثر من 25 طلبية أو اطلب طلبات بقيمة تتجاوز ال 5000
            ريال سعودي حتى تصبح زبون ذهبي لدينا و تتمتع بالعروض الكثيرة.
          </span>
        </div>
        <div className="col-5 selected-col">
          <span>2</span>
          <img src={Gold} className="Gold" alt="Gold"></img>
          <span>{translate("Gold", locale)}</span>
        </div>
      </div>
      {/* SILVER */}
      <div className="medals-container row animate__animated animate__fadeInLeft animate__delay-2s">
        <div className="col-5 selected-col">
          <span>3</span>
          <img src={Silver} className="Silver" alt="Silver"></img>
          <span>{translate("Silver", locale)}</span>
        </div>
        {/* <div className="col"></div> */}
        <div className="col text-medal-Silver">
          <span>
            هيّا قم بطلب أكثر من 15 طلبية أو اطلب طلبات بقيمة تتجاوز ال 2000
            ريال سعودي حتى تصبح زبون فضي لدينا و تتمتع بالعروض الكثيرة.
          </span>
        </div>
      </div>
      {/* BRONZE */}
      <div className="medals-container row animate__animated animate__fadeInLeft animate__delay-3s">
        <div className="col text-medal-Bronze">
          <span>
            أهلاً بك في عائلتنا.. قم بالاستفادة من خدماتنا لتصلك العروض بشكل
            أكبر.
          </span>
        </div>
        <div className="col-5 selected-col">
          <span>4</span>
          <img src={Bronze} className="Bronze" alt="Bronze"></img>
          <span>{translate("Bronze", locale)}</span>
        </div>
      </div>
    </div>
  );
};

export default SystemWork;
